<template>
  <div class="flex flex-col gap-y-[24px] bg-surface-primary p-[16px] rounded-[8px] mb-[50px]">
   <!-- Form item -->
   <div class="flex flex-col gap-y-[8px]">
      <div class="flex gap-x-[2px] text-heading-secondary title-14-medium-500">
        <RequiredIndicator :filled="!!templateFormData.name && isNameValid" />
        <span class="leading-[16px]">Наименование</span>
      </div>
      <div class="relative flex flex-col gap-y-[4px]">
        <VInput v-model="templateFormData.name" placeholder="Введите название шаблона" contentWidth @blur="validateName" :error="!isNameValid" />
        <div v-if="!isNameValid" class="note-12-reg-400 text-v-ui-root-service-alarm"> Заполните обязательное поле </div>
      </div>
    </div>
    <!-- End form item -->

    <!-- Form item -->
    <div class="flex flex-col gap-y-[8px]">
      <div class="flex gap-x-[2px] text-heading-secondary title-14-medium-500">
        <span class="leading-[13px]">Описание</span>
      </div>
      <VTextArea v-model="templateFormData.description" placeholder="Добавьте описание" size="m" resizable />
    </div>
    <!-- End form item -->

    <!-- Form item -->
   <div class="flex flex-col gap-y-[8px]">
      <div class="flex gap-x-[2px] text-heading-secondary title-14-medium-500">
        <RequiredIndicator :filled="!!templateFormData.priority" />
        <span class="leading-[16px]">Приоритет</span>
      </div>
        <VSelector
          :value="templateFormData.priority"
          :items="priorities"
          placeholder="Выберите приоритет из списка"
          absolute
          variant="gray"
          class="h-[40px]"
          size="m"
          @input="(value) => templateFormData.priority = value"
        />
    </div>
    <!-- End form item -->

    <!-- Form item -->
   <div class="flex flex-col gap-y-[8px]">
      <div class="flex gap-x-[2px] text-heading-secondary title-14-medium-500">
        <RequiredIndicator :filled="!!templateFormData.slaMinutes && isSlaMinutesValid" />
        <span class="leading-[16px]">Время на выполнение задачи, дни</span>
      </div>
      <div class="flex flex-col gap-y-[4px]">
        <VInput
          v-model="templateFormData.slaMinutes"
          placeholder="Введите количество дней"
          contentWidth
          @blur="validateSlaMinutes"
          :error="!isSlaMinutesValid"
          type="number"
          min="1"
          max="60"
          step="1"
        />
        <div v-if="!isSlaMinutesValid" class="note-12-reg-400 text-v-ui-root-service-alarm"> Заполните обязательное поле </div>
      </div>
    </div>
    <!-- End form item -->

       <!-- Form item -->
   <div class="flex flex-col gap-y-[8px]">
      <div class="flex gap-x-[2px] text-heading-secondary title-14-medium-500">
        <RequiredIndicator :filled="!!templateFormData.roles" />
        <span class="leading-[16px]">Задача по шаблону доступна</span>
      </div>

      <VCellGroup :cells="generateRolesCells()" v-model="templateFormData.roles"/>

    </div>
    <!-- End form item -->

    <!-- Buttons -->
    <div class="flex justify-start gap-x-[8px]">
      <VButton type="light" size="m" @click="openBackDialog" label="Назад" />
      <VButton size="m" @click="saveHandler" :label="saveButtonLabel" :disabled="saveButtonDisabled" />
    </div>
    <!-- End buttons -->

    <!-- Back dialog -->
    <VDialog
     v-model="isBackDialogOpen"
     :title="dialogConfig.title"
     :subtitle="dialogConfig.subtitle"
     :leftButton='dialogConfig.leftButton'
     :rightButton='dialogConfig.rightButton'
    />
    <!-- End back dialog -->
  </div>
</template>

<script>
import { VInput, VTextArea, VSelector, VButton, VDialog, VCellGroup } from '@gostelemed.front/rt-doctis.designsystem';
import kzsTemplateService from '@/services/kzs/kzs-templates/kzs-template.service';
import { TOASTS } from '@/services/core/ui/toasts.const';
import RequiredIndicator from '@/components/base/RequiredIndicator.vue';

export default {
  name: 'KzsTemplateForm',
  components: {
    VInput,
    VTextArea,
    VSelector,
    VButton,
    VDialog,
    VCellGroup,
    RequiredIndicator,
  },
  props: {
    template: {
      type: Object,
      default: () => ({}),
    },
    editMode: {
      type: Boolean,
      default: false,
    },
    backBtnActive: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      roles: [
        {
          id: 1,
          title: 'Лечащему врачу',
        },
        {
          id: 2,
          title: 'Врачу-специалисту',
        },
        {
          id: 3,
          title: 'Медицинскому работнику колл-центра',
        },
      ],
      isNameValid: true,
      isSlaMinutesValid: true,
      isBackDialogOpen: false,
      isRequestProcessing: false,
      templateFormData: {
        name: null,
        description: '',
        priority: null,
        slaMinutes: null,
        roles: null,
      },
      priorities: [
        {
          id: 0,
          title: 'Критический',
          value: 3,
        },
        {
          id: 1,
          title: 'Высокий',
          value: 2,
        },
        {
          id: 2,
          title: 'Средний',
          value: 1,
        },
        {
          id: 3,
          title: 'Низкий',
          value: 0,
        },
      ],
    }
  },
  watch: {
    backBtnActive(newVal) {
      if (newVal) {
        this.openBackDialog();
      }
    },
  },
  computed: {
    dialogConfig() {
      if (this.editMode) {
        return {
          title: 'Редактирование шаблона',
          subtitle: 'Вы хотите прервать редактирование? Изменения не сохранятся.',
          leftButton: { label: 'Прервать', handler: () => this.confirmCancelHandler() },
          rightButton: { label: 'Не прерывать', handler: () => this.closeBackDialog() },
        };
      }
      return {
        title: 'Добавление шаблона задачи КЗС',
        subtitle: 'Вы хотите прервать добавление шаблона? Введённые данные не сохранятся.',
        leftButton: { label: 'Прервать', handler: () => this.confirmBackHandler() },
        rightButton: { label: 'Не прерывать', handler: () => this.closeBackDialog() },
      };
    },
    saveButtonLabel() {
      return this.editMode ? 'Сохранить изменения' : 'Добавить';
    },
    saveButtonDisabled() {
      return !this.templateFormData.name || !this.templateFormData.priority || !this.templateFormData.slaMinutes || this.isRequestProcessing || !this.templateFormData.roles;
    },
  },
  mounted() {
    if (this.editMode && this.template?.name) {
      this.templateFormData = {...this.template};

      // Перевод времени на выполнение задачи из минут в дни
      this.templateFormData.slaMinutes = this.templateFormData.slaMinutes / 1440;

      // Загрузка приоритета из массива приоритетов
      this.templateFormData.priority = this.priorities.find((priority) => priority.value === this.templateFormData.priority);

      // Загрузка роли из массива ролей
      if (this.templateFormData.roles?.length) {
        this.templateFormData.roles = this.roles.find(role => this.templateFormData.roles[0] === role.id);
      }
    }
  },
  methods: {
    openBackDialog() {
      this.isBackDialogOpen = true;
    },
    closeBackDialog() {
      this.isBackDialogOpen = false;
      this.$emit('update:backBtnActive', false);
    },
    confirmBackHandler() {
      this.$router.push('/remote-monitoring/kzs/templates');
    },
    confirmCancelHandler() {
      this.isBackDialogOpen = false;
      this.$emit('cancel');
    },
    async saveHandler() {
      this.isRequestProcessing = true;
      const resultTemplateParams = {
        name: this.templateFormData.name,
        description: this.templateFormData.description,
        priority: this.templateFormData.priority.value,
        slaMinutes: this.templateFormData.slaMinutes * 1440,
        roles: [this.templateFormData.roles?.id],
      };
      if (this.editMode) {
        await this.updateTemplate(resultTemplateParams);
      } else {
        await this.createTemplate(resultTemplateParams);
      }
      this.isRequestProcessing = false;
    },
    async updateTemplate(resultTemplateParams = {}) {
      try {
        const updatedTemplate = await kzsTemplateService.updateKzsTemplate(this.template.id, resultTemplateParams);
        if(updatedTemplate) {
          this.$uiService.showToast(TOASTS.KZS_TEMPLATE_UPDATE_SUCCESS);
          this.$emit('updateTemplate', updatedTemplate);
        } else {
          this.$uiService.showToast(TOASTS.KZS_TEMPLATE_UPDATE_ERROR);
        }
      } catch (error) {
        console.error('Ошибка при обновлении шаблона задачи КЗС:', error);
        this.$uiService.showToast(TOASTS.KZS_TEMPLATE_UPDATE_ERROR);
      } finally {
        this.isRequestProcessing = false;
      }
    },
    async createTemplate(resultTemplateParams = {}) {
      try {
        const response = await kzsTemplateService.createKzsTemplate(resultTemplateParams);
        if (response) {
          this.$uiService.showToast(TOASTS.KZS_TEMPLATE_CREATE_SUCCESS);
          this.$router.push(`/remote-monitoring/kzs/templates/${response.id}`);
        } else {
          this.$uiService.showToast(TOASTS.KZS_TEMPLATE_CREATE_ERROR);
        }
      } catch (error) {
        console.error('Ошибка при создании шаблона задачи КЗС:', error);
        this.$uiService.showToast(TOASTS.KZS_TEMPLATE_CREATE_ERROR);
      } finally {
        this.isRequestProcessing = false;
      }
    },
    validateName() {
      if (!this.templateFormData.name) {
        this.isNameValid = false;
      } else {
        if (this.templateFormData.name.length > 1000) {
          this.templateFormData.name = this.templateFormData.name.slice(0, 1000);
        }
        this.isNameValid = true;
      }
    },
    validateSlaMinutes() {
      if (this.templateFormData.slaMinutes) {
        if(this.templateFormData.slaMinutes < 1) {
          this.templateFormData.slaMinutes = 1;
        } else if(this.templateFormData.slaMinutes > 60) {
          this.templateFormData.slaMinutes = 60;
        }
        this.isSlaMinutesValid = true;
      } else {
        this.isSlaMinutesValid = false;
      }
    },
    generateRolesCells() {
      return this.roles.map(role => {
        return {
          wrapSubtitle: true,
          type: 'radio',
          title: role.title,
          variant: 'gray',
          displayValue: true,
          currentValue: {
            ...role,
          },
        }
      })
    },
  },
}
</script>
